import axios from 'axios';

const API_BASE_URL = ''; 

const apiService = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Example GET request
export const fetchData = async (endpoint) => {
    try {
        const response = await apiService.get(endpoint, {
            headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

// Example POST request
export const postData = async (endpoint, data) => {
    try {
        const response = await apiService.post(endpoint, data, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error posting data:', error);
        throw error;
    }
};

// Example PUT request
export const updateData = async (endpoint, data) => {
    try {
        const response = await apiService.put(endpoint, data);
        return response.data;
    } catch (error) {
        console.error('Error updating data:', error);
        throw error;
    }
};

// Example DELETE request
export const deleteData = async (endpoint) => {
    try {
        const response = await apiService.delete(endpoint);
        return response.data;
    } catch (error) {
        console.error('Error deleting data:', error);
        throw error;
    }
};

export default apiService;